import React, { Fragment, useState } from 'react';
import {
    TabContent, TabPane, Nav, NavItem, NavLink, Row, Label
} from 'reactstrap';
import Navbarh from '../navbar/Navbar';
import '../estilos.css';
import * as IoIcons from 'react-icons/io';
import * as RiIcons from 'react-icons/ri'
import Pagination from "react-js-pagination";
import Moment, { updateLocale } from 'moment';
import classnames from 'classnames';
import Respaldo from './Respaldo';
import RPProduccion from './RPProduccion';
import Autorizaciones from './Autorizaciones';
import Tools from './Tools';
import RIClinentes from './RIClinentes';



const initialfFormState = { formType: 'Administrar' }


function Administrar() {
    //Declaración de variables  
    const [formState, updateFormState] = useState(initialfFormState);
    const [reporte, setReporte] = useState("");
    const { formType } = formState;
    const userName = window.$name;
    const padministrar = window.$Administrar ? window.$Administrar : false;
    const [activeTab, setActiveTab] = useState('1');


    const toggle1 = tab => {
        if (activeTab !== tab) setActiveTab(tab);
    }


    return (
        <>
            <Navbarh />
            {padministrar == true && (
                <>
                    <Row>
                        <div className="headerp col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <RiIcons.RiAdminFill className="iconoc floatleft" onClick={() => { toggle1('1'); }} />
                            <h3 >{formType}</h3>
                        </div>
                    </Row>
                    <div className="conteiner2">
                        <Fragment>
                            <div>
                                <Nav tabs>
                                    <NavItem>
                                        <NavLink
                                            className={classnames({ active: activeTab === '1' })}
                                            onClick={() => { toggle1('1'); }}
                                        >
                                            Autorizaciones
                                        </NavLink>
                                    </NavItem>
                                    <NavItem >
                                        <NavLink
                                            className={classnames({ active: activeTab === '2' })}
                                            onClick={() => { toggle1('2'); }}
                                        >
                                            Reportes
                                        </NavLink>
                                    </NavItem>
                                    <NavItem className={userName !== "GELA" ? "displaynone" : ""}>
                                        <NavLink
                                            className={classnames({ active: activeTab === '3' })}
                                            onClick={() => { toggle1('3'); }}
                                        >
                                            Respaldos
                                        </NavLink>
                                    </NavItem>
                                    <NavItem className={userName !== "GELACIA.PALACIOS" ? "displaynone" : ""}>
                                        <NavLink
                                            className={classnames({ active: activeTab === '4' })}
                                            onClick={() => { toggle1('4'); }}
                                        >
                                            Tools
                                        </NavLink>
                                    </NavItem>
                                </Nav>
                                <TabContent activeTab={activeTab}>
                                    <TabPane tabId="1">
                                        <Autorizaciones />
                                    </TabPane>
                                    <TabPane tabId="2">
                                        <div class="col-lg-6 col-md-9 col-sm-12 col-xs-12 text-left  margintopmobil20px" >

                                            <Label><h5>Reporte: </h5></Label>
                                            <select name="searchBy" className="ml-2" onChange={(e) => setReporte(e.target.value)}>
                                                <option value="" selected={reporte === "" ? true : false}>Elije una opción</option>
                                                <option value="RIClinentes" selected={reporte === "RIClinentes" ? true : false}>Inventario de existencia por cliente</option>
                                                <option value="RPProduccion" selected={reporte === "RPProduccion" ? true : false}>Plan de producción por fecha de reciba</option>
                                            </select>
                                        </div>
                                        {reporte === "RPProduccion" && (<RPProduccion />)}
                                        {reporte === "RIClinentes" && (<RIClinentes />)}
                                    </TabPane>
                                    <TabPane tabId="3">
                                        {userName === "GELA" && (
                                            <Respaldo />
                                        )}
                                    </TabPane>
                                    <TabPane tabId="4" >
                                        <Tools />
                                    </TabPane>
                                </TabContent>
                            </div>



                        </Fragment>
                    </div>
                </>
            )}
        </>
    )
};



export default Administrar

